import React from 'react'
import { Spinner } from '@blueprintjs/core'

import { Box } from '.'
import Text from './text'

const CenterSpinner = ({ message }: { message?: string }) => (
  <Box height="1" width="1" justify="center" items="center" flexDir="col">
    <Spinner />
    {message && (
      <>
        &nbsp;<Text muted>{message}</Text>
      </>
    )}
  </Box>
)

export default CenterSpinner
